import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getLocaleConfig, ILocaleConfig } from '../constants/locales';

export const useLocale = () => {
  const { i18n } = useTranslation();
  
  const [locale, setLocale] = useState<ILocaleConfig>(
    getLocaleConfig(i18n.language)
  );

  useEffect(() => {
    setLocale(getLocaleConfig(i18n.language));
  }, [i18n.language]);

  return locale;
};